import { SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER } from "../../constants";
import { setDismissed } from "../../../../../services/notificationsOptIn";
import notificationsOptInDismissEvent from "../../../../../services/dataLayer/notificationsOptInDismissEvent";

export const dismissNotificationsOptInBanner = () => dispatch => {
  setDismissed();
  notificationsOptInDismissEvent();
  dispatch({
    type: SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER,
    payload: { show: false, isSuccess: false }
  });
};
